'use client';

import Image from 'next/image';
import { type HTMLAttributes, type ReactElement } from 'react';

import calmLogoGradient from '@/../public/_n/images/calm-logo-gradient.png';

import styles from './styles.module.css';

const Container = ({
	alignment,
	children,
	...props
}: HTMLAttributes<HTMLDivElement> & { alignment?: 'left' | 'center' }) => (
	<div {...props} className={alignment === 'left' ? styles.containerLeft : styles.containerCenter}>
		{children}
	</div>
);

const ImageContainer = ({ children, ...props }: HTMLAttributes<HTMLDivElement>) => (
	<div {...props} className={styles.imageContainer}>
		{children}
	</div>
);

export type BrandingProps = {
	/**
	 * @defaultValue
	 * ```tsx
	 * "sisu-branding"
	 * ```
	 */
	'data-testid'?: string;

	ourLogo?: ReactElement;

	/**
	 * @defaultValue
	 * ```tsx
	 * null
	 * ```
	 */
	theirLogo?: ReactElement | null;
};

export default function Branding({
	'data-testid': testId = 'sisu-branding',
	ourLogo = (
		<Image
			alt="Calm Logo"
			data-testid={`${testId}-calm-logo`}
			fill
			src={calmLogoGradient}
			style={{ objectFit: 'contain' }}
			unoptimized
		/>
	),
	theirLogo = null,
}: BrandingProps) {
	return (
		<Container data-testid={testId}>
			<ImageContainer>{ourLogo}</ImageContainer>
			{theirLogo && <ImageContainer>{theirLogo}</ImageContainer>}
		</Container>
	);
}
